import { makeStyles, createStyles, Theme } from "@material-ui/core";
import { ReactNode, HTMLProps, PropsWithChildren } from "react";
import clsx from "clsx";

type CellOwnProps = PropsWithChildren<{
  title: string | ReactNode;
  action?: ReactNode;
  fullWidth?: boolean;
}>;

export type CellProps = CellOwnProps & Omit<HTMLProps<HTMLDivElement>, keyof CellOwnProps>;

export const Cell = ({ title, action, children, fullWidth = false, ...props }: CellProps) => {
  const classes = useStyles();
  return (
    <div className={clsx({ [classes.cell]: true, [classes.cellFullWidth]: fullWidth })} {...props}>
      <div className={classes.header}>
        <div className={classes.title}>{title}</div>
        {action && <div className={classes.action}>{action}</div>}
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cell: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: "50%",
      paddingBottom: theme.spacing(2),
      fontFamily: theme.typography.fontFamily,
      minWidth: 200,
    },
    cellFullWidth: {
      flexBasis: "100%",
    },
    header: {
      textTransform: "uppercase",
      fontSize: 12,
      fontWeight: "bold",
      lineHeight: "19px",
      color: theme.palette.dark.main,
      letterSpacing: 1,
    },
    content: {
      fontSize: "inherit",
      fontWeight: 400,
      lineHeight: "24px",
      paddingTop: theme.spacing(0.5),
      color: theme.palette.battleshipGrey.main,
    },
    title: {
      display: "inline-block",
      verticalAlign: "middle",
    },
    action: {
      display: "inline-block",
      marginLeft: theme.spacing(1),
    },
  }),
);
